import React, { Component } from 'react';

import { Column, Row } from 'simple-flexbox';
import ManagePSP from './ManagePSP';

class EditPSP extends Component {
  state = {};

  render() {
    return <Row flexGrow={ 1 } className='module apidata viewClient' vertical='start'>
      <Column flexGrow={ 1 }>
        <ManagePSP pspId={ this.props.match.params.pspId } viewOrEdit={ 2 }/>
      </Column>
    </Row>;
  }
}

export default EditPSP;